"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDriversCompany = exports.isCompanyDriver = exports.isDriver = exports.User = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const graphql_1 = require("../graphql");
const orm_1 = require("../orm");
const transformToDate_1 = require("../transformers/transformToDate");
const BillingInformation_1 = require("./BillingInformation");
const Driver_1 = require("./Driver");
const DriversCompany_1 = require("./DriversCompany");
const DynamicFormFieldsValues_1 = require("./DynamicFormFieldsValues");
const HyperwalletInformation_1 = require("./HyperwalletInformation");
const MangopayInformation_1 = require("./MangopayInformation");
const ProfilePhoto_1 = require("./ProfilePhoto");
const StripeInformation_1 = require("./StripeInformation");
const SuspiciousCCActivityIssue_1 = require("./SuspiciousCCActivityIssue");
const TravelAgent_1 = require("./TravelAgent");
const UserAutomaticEmail_1 = require("./UserAutomaticEmail");
const UserRoles_1 = require("./UserRoles");
const Wishlist_1 = require("./Wishlist");
let User = class User extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this._id = (0, uuid_1.v4)();
        this.createdAt = new Date();
        this.email = "";
        this.otherEmails = [];
        this.paypalEmail = "";
        this.passwordHash = `purposefullyInvalidInitialHash${Math.floor(Math.random() * 1000000000)}`;
        this.firstName = "";
        this.lastName = "";
        this.phoneNumber = "";
        this.whatsappNumber = "";
        this.mangopayInformation = [];
        this.billingInformation = [];
        this.otherPhoneNumbers = [];
        this.vehicleIds = [];
        this.automaticEmails = [];
        this.suspiciousCCActivity = false;
        this.version = 0;
        this.distanceUnit = legacy_enums_1.DistanceUnit.Kilometers;
        this.fcmRegistrationTokens = [];
        // set default based on order
        this.currency = legacy_enums_1.Currency.Euro;
        this.wishlist = {
            routeIds: [],
            stopIds: [],
            cityIds: [],
        };
        this.optedOutOfMarketing = true;
    }
    isMangopayInformationSet() {
        return !!this.mangopayInformation && !!this.mangopayInformation[this.mangopayInformation.length - 1];
    }
    get activeMangopayInformation() {
        if (this.driver || this.driversCompany) {
            const billingInformation = this.billingInformation.find((bi) => bi.isActive);
            if (billingInformation) {
                return this.mangopayInformation.find((mi) => mi.billingInformationId === billingInformation._id);
            }
        }
        return this.mangopayInformation.find((mi) => (0, utils_1.isUndefinedOrNull)(mi.disabledAt));
    }
    get activeMangopayInformationIndex() {
        if (this.driver || this.driversCompany) {
            const billingInformation = this.billingInformation.find((bi) => bi.isActive);
            if (billingInformation) {
                return this.mangopayInformation.findIndex((mi) => mi.billingInformationId === billingInformation._id);
            }
        }
        return this.mangopayInformation.findIndex((mi) => (0, utils_1.isUndefinedOrNull)(mi.disabledAt));
    }
    getActiveMangopayInformationOrFail() {
        const info = this.activeMangopayInformation;
        if (!info) {
            throw Error(`No active mangopay information found on user ${this._id}`);
        }
        return info;
    }
    get invoicingBillingInformation() {
        return this.billingInformation.find((bi) => bi.isInvoiceInformation && !bi.deletedAt);
    }
    get fullName() {
        return [this.firstName, this.lastName].join(" ");
    }
    isKYCValid() {
        try {
            if (!this.isMangopayInformationSet()) {
                return false;
            }
            const active = this.getActiveMangopayInformationOrFail();
            return active.KYCLevel === legacy_enums_1.KYCLevel.Regular;
        }
        catch (e) {
            return false;
        }
    }
};
exports.User = User;
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4", { always: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "_id", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)({ always: true }),
    (0, class_validator_1.IsDefined)({ always: true }),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], User.prototype, "createdAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)({ always: true }),
    (0, class_validator_1.IsDate)({ always: true }),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], User.prototype, "deletedAt", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)({ always: true }),
    (0, class_validator_1.IsDate)({ groups: ["profile"] }),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], User.prototype, "birthdayAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4", { groups: ["profile"] }),
    (0, class_validator_1.IsOptional)({ always: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "countryId", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, orm_1.CDIndex)(),
    __metadata("design:type", String)
], User.prototype, "facebookId", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, orm_1.CDIndex)(),
    __metadata("design:type", String)
], User.prototype, "appleUserId", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "appleUserToken", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProfilePhoto_1.ProfilePhoto),
    (0, class_validator_1.ValidateNested)({ groups: ["profile"] }),
    (0, class_validator_1.IsOptional)({ always: true }),
    __metadata("design:type", ProfilePhoto_1.ProfilePhoto)
], User.prototype, "profilePhoto", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ always: true }),
    (0, class_validator_1.IsUrl)(undefined, { groups: ["profile"] }),
    __metadata("design:type", String)
], User.prototype, "profilePhotoUrl", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDefined)({ groups: ["profile", "credentials"] }),
    (0, class_validator_1.IsEmail)(undefined, { groups: ["profile", "credentials"] }),
    (0, class_validator_1.Length)(5, 48, { groups: ["profile", "credentials"] }),
    (0, class_validator_1.IsString)({ groups: ["profile", "credentials"] }),
    (0, class_validator_1.ValidateIf)((user) => !user.driver ||
        (user.driver && !user.driver.driversCompanyUserId) ||
        (user.driver && user.driver.driversCompanyUserId && user.email && user.email.length > 0), {
        groups: ["profile", "credentials"],
    }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => value && value.trim().toLowerCase()),
    __metadata("design:type", String)
], User.prototype, "email", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (value && Array.isArray(value) ? value.filter((item) => String(item) !== "") : [])),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], User.prototype, "otherEmails", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.Length)(5, 48),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (!value ? undefined : value)),
    __metadata("design:type", String)
], User.prototype, "paypalEmail", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)({ groups: ["credentials"] }),
    (0, class_validator_1.IsDefined)({ groups: ["credentials"] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "passwordHash", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.Length)(0, 48, { groups: ["profile"] }),
    (0, class_validator_1.IsString)({ groups: ["profile"] }),
    (0, class_validator_1.IsNotEmpty)({ groups: ["profile"] }),
    (0, class_validator_1.ValidateIf)((user) => !!user.driver || !!user.driversCompany || !!user.travelAgent, { groups: ["profile"] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "firstName", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.Length)(0, 48, { groups: ["profile"] }),
    (0, class_validator_1.IsString)({ groups: ["profile"] }),
    (0, class_validator_1.IsNotEmpty)({ groups: ["profile"] }),
    (0, class_validator_1.ValidateIf)((user) => !!user.driver || !!user.driversCompany || !!user.travelAgent, { groups: ["profile"] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "lastName", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["profile", "driver"] }),
    (0, class_validator_1.ValidateIf)((_user, driver) => !(0, utils_1.isUndefinedOrNull)(driver), { groups: ["profile", "driver"] }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Driver_1.Driver),
    (0, class_transformer_1.Transform)((value, obj) => {
        if (value instanceof Driver_1.Driver && obj.countryId !== legacy_config_1.US_COUNTRY_ID) {
            value.regionId = undefined;
        }
        return value;
    }),
    __metadata("design:type", Driver_1.Driver)
], User.prototype, "driver", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["profile", "driverCompany"] }),
    (0, class_validator_1.ValidateIf)((_user, driversCompany) => !(0, utils_1.isUndefinedOrNull)(driversCompany), { groups: ["profile", "driverCompany"] }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DriversCompany_1.DriversCompany),
    __metadata("design:type", DriversCompany_1.DriversCompany)
], User.prototype, "driversCompany", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(() => TravelAgent_1.TravelAgent),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["travelAgent"] }),
    (0, class_validator_1.ValidateIf)((_user, travelAgent) => !(0, utils_1.isUndefinedOrNull)(travelAgent), { groups: ["travelAgent"] }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => TravelAgent_1.TravelAgent),
    __metadata("design:type", TravelAgent_1.TravelAgent)
], User.prototype, "travelAgent", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.Length)(4, 18, { groups: ["profile"] }),
    (0, class_validator_1.ValidateIf)((user) => !!user.driver, { groups: ["profile"] }),
    (0, class_validator_1.IsString)({ groups: ["profile"] }),
    (0, class_validator_1.IsDefined)({ groups: ["profile"] }),
    (0, class_transformer_1.Transform)((value) => (0, utils_1.transformPhoneNumberToNormalizedForm)(value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "phoneNumber", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.Length)(0, 18, { groups: ["profile"] }),
    (0, class_validator_1.IsString)({ groups: ["profile"] }),
    (0, class_validator_1.IsDefined)({ groups: ["profile"] }),
    (0, class_transformer_1.Transform)((value) => (0, utils_1.transformPhoneNumberToNormalizedForm)(value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "whatsappNumber", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.PayoutType, { groups: ["billing", "driver", "driverCompany"], message: "invalid payout type" }),
    (0, class_validator_1.IsOptional)({ groups: ["billing", "driver", "driverCompany"] }),
    __metadata("design:type", Number)
], User.prototype, "payoutType", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(() => [MangopayInformation_1.MangopayInformation]),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Transform)((value) => (!value ? [] : (0, class_transformer_1.plainToClass)(MangopayInformation_1.MangopayInformation, value))),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => MangopayInformation_1.MangopayInformation),
    __metadata("design:type", Array)
], User.prototype, "mangopayInformation", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["hyperwalletInformation"] }),
    (0, class_validator_1.ValidateIf)((_user, hyperwalletInformation) => !!hyperwalletInformation, { groups: ["hyperwalletInformation"] }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => HyperwalletInformation_1.HyperwalletInformation),
    __metadata("design:type", HyperwalletInformation_1.HyperwalletInformation)
], User.prototype, "hyperwalletInformation", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["stripeInformation"] }),
    (0, class_validator_1.ValidateIf)((_user, stripeInformation) => !!stripeInformation, { groups: ["stripeInformation"] }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => StripeInformation_1.StripeInformation),
    __metadata("design:type", StripeInformation_1.StripeInformation)
], User.prototype, "stripeInformation", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["billing"] }),
    (0, class_validator_1.Validate)(BillingInformation_1.BillingInformation, { groups: ["billing"] }),
    (0, class_transformer_1.Transform)((value) => (!value ? [] : (0, class_transformer_1.plainToClass)(BillingInformation_1.BillingInformation, value))),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => BillingInformation_1.BillingInformation),
    __metadata("design:type", Array)
], User.prototype, "billingInformation", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateNested)({ groups: ["profile", "driver", "driverCompany"] }),
    (0, class_validator_1.Validate)(DynamicFormFieldsValues_1.DynamicFormFieldsValues, { groups: ["profile", "driver", "driverCompany"] }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DynamicFormFieldsValues_1.DynamicFormFieldsValues),
    __metadata("design:type", DynamicFormFieldsValues_1.DynamicFormFieldsValues)
], User.prototype, "dynamicFormFieldsValues", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)({ groups: ["profile"] }),
    (0, class_validator_1.IsDefined)({ groups: ["profile"] }),
    (0, class_transformer_1.Type)(() => String),
    (0, class_transformer_1.Transform)((value) => value && Array.isArray(value)
        ? value.map(utils_1.transformPhoneNumberToNormalizedForm).filter((item) => String(item) !== "")
        : []),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], User.prototype, "otherPhoneNumbers", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UserRoles_1.UserRoles),
    (0, class_validator_1.ValidateNested)({ groups: ["profile"] }),
    (0, class_validator_1.IsOptional)({ always: true }),
    __metadata("design:type", UserRoles_1.UserRoles)
], User.prototype, "userRoles", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], User.prototype, "vehicleIds", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UserAutomaticEmail_1.UserAutomaticEmail),
    __metadata("design:type", Array)
], User.prototype, "automaticEmails", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], User.prototype, "suspiciousCCActivity", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => SuspiciousCCActivityIssue_1.SuspiciousCCActivityIssue),
    __metadata("design:type", Array)
], User.prototype, "suspiciousCCActivityIssues", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], User.prototype, "version", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], User.prototype, "lastLoginAt", void 0);
__decorate([
    (0, graphql_1.GField)(() => legacy_enums_1.DistanceUnit),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], User.prototype, "distanceUnit", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "discountCode", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], User.prototype, "fcmRegistrationTokens", void 0);
__decorate([
    (0, graphql_1.GField)(() => legacy_enums_1.Currency),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], User.prototype, "currency", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], User.prototype, "verifiedAt", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(() => Wishlist_1.Wishlist),
    (0, class_transformer_1.Expose)(),
    (0, orm_1.CDColumn)(),
    __metadata("design:type", Object)
], User.prototype, "wishlist", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], User.prototype, "customerNote", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], User.prototype, "stripeCustomerId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    __metadata("design:type", Object)
], User.prototype, "publicOffersPreferences", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    __metadata("design:type", Object)
], User.prototype, "claimingToolConfig", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], User.prototype, "cooperationAgreementSignedAs", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], User.prototype, "optedOutOfMarketing", void 0);
exports.User = User = __decorate([
    (0, orm_1.CDEntity)("users"),
    (0, graphql_1.GObjectType)("User")
], User);
function isDriver(user) {
    return !!user.driver;
}
exports.isDriver = isDriver;
function isCompanyDriver(user) {
    return !!user.driver?.driversCompanyUserId;
}
exports.isCompanyDriver = isCompanyDriver;
function isDriversCompany(user) {
    return !!user.driversCompany;
}
exports.isDriversCompany = isDriversCompany;
//# sourceMappingURL=User.js.map